import { TextField } from '@mui/material';
import { forwardRef } from 'react';
import ReactPhoneInput from 'react-phone-number-input/input';

const WrapPhoneInput = (props, ref) => {
  return (
    <TextField
      {...props}
      inputRef={ref}
      size="small"
      variant="outlined"
      name="phone"
    />
  );
};

const forwardInput = forwardRef(WrapPhoneInput);

export default function PhoneInput({ value, onChange, error, ...props }) {
  return (
    <ReactPhoneInput
      value={value}
      onChange={event => onChange(event || null)}
      country="US"
      inputComponent={forwardInput}
      error={error}
      {...props}
    />
  );
}
